<template>
  <div>
    <Title :title="'日均站点负荷率'" :isActiveSec="true"></Title>
    <Chart :cdata="cdata" :width="style.width" :height="style.height"/>
  </div>
</template>

<script>
import Chart from '../chart.vue'
import Title from '../../title.vue'
import { indexLeft } from '@/api/indexLeft';
import { dataInterface } from '@/api/dataInterfaceApi';

export default {
  data () {
    return {
      cdata: {
        category: [],
        rateData: [],
        id:"loadRateBar",
        legendData:[],
        series:[
          {
            name: "",
            type: "bar",
            barWidth: 10,
            itemStyle: {
              normal: {
                color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  { offset: 0, color: "#00D3FF" },
                  { offset: 1, color: "#1953FC" }
                ])
              }
            },
            label: {
                show: true,
                position: 'top',
                color:"#82A9EF"
            },
            data: []
          }
        ],
        yAxisname:"(%)"
      },
      style:{
        width: '500',
        height: '180'
      }
    };
  },
  components: {
    Chart,
    Title
  },
  mounted () {
    
  },
  methods: {
    getData(data){
      this.selectDaylyStationLoadRate(data);
    },
    selectDaylyStationLoadRate(data={}){
      let _this = this;
      let params = {};
				if(data){
				//建设中--省市区
				params = {
					"enCode":"TiDB-shengshiqu-zhandianfuhelv",
    			"@province":data.province||data.city||data.district
				}
			}else {
				params = {
					"enCode":"TiDB-quanguo-zhandianrijunfuhelv"//全国
				}
			}
      dataInterface
        .dataFaceApi(params)
        .then((res) => {
          if(!res) return;
          let DayStationLod = [];
          let xList = [];
					res.forEach(item=>{
            DayStationLod.push(item.DayStationLod);
            xList.push(item.cur_date);
          })
					this.cdata.series[0].data = DayStationLod;//运营List  
          this.cdata.category = xList;
        })
        .catch((err) => {
          console.log(err);
        });
    }, 
  }
};
</script>

<style lang="scss" scoped>
</style>